import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import type { ComponentType, ReactNode } from 'react'
import Layout from '@/layouts/Layout'
import '../styles/application.css'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true })
    const page = pages[`../pages/${name}.tsx`] as {
      default: ComponentType & { layout?: (page: ReactNode) => ReactNode }
    }
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    // Apply default layout if the page doesn't define its own
    page.default.layout = page.default.layout || ((page: ReactNode) => <Layout>{page}</Layout>)
    return page
  },
  setup({ el, App, props }) {
    const root = createRoot(el)
    root.render(<App {...props} />)
  },
})
